#import "../nut-email-address-fragment.graphql"

fragment EmailQueuedFragmentSparse on EmailQueued {
    id
    subject
    bodyExcerpt
    attachments {
        fileId
        name
        href
        fileType
    }
    to {
        ...NutEmailAddressFragment
    }
    from {
        ...NutEmailAddressFragment
    }
    canRetry
    isFailed
    htmlUrl
}
